/**
 * @file コンポーネント：プライバシーポリシー英語 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledPrivacypolicyBody } from "./style";

// Presenterを返す
export const Presenter = () => {
    // ReactDOM
    return (
        <StyledPrivacypolicyBody>
            <h3>
                Personal Information Protection Policy (Privacy Policy)
            </h3>
            <p>
                You can experience surgery no matter what your location in the world is, even if you are not present in the operating room! This is made possible by OPExPARK, which uses IoT technology to digitalize the operation theater.
            </p>
            <p>
                Digitizing the entire operating room, allowing us to visualize implicit information such as surgical strategies and intraoperative decisions, enables us to digitize the operating room as it is. Furthermore, it provides a new platform for sharing information across regional and border walls as if you were at the same location.
            </p>
            <p>
                We can expect AI surgery and robotic surgery with a data-driven approach in the future, as well as smart hospitals and smart medical facilities.
            </p>
            <p>
                To accomplish our mission, we will create the intraoperative information fusion platform "OPeLiNK" to demonstrate the outstanding medical skills that individuals have accumulated, and a platform for learning manual skills called "opeXpark" so students can learn these skills without going abroad to study. By visualizing excellent surgical techniques, and by allowing users to learn surgical techniques as if they were within the operating room, we are trying to correct the disparity in surgical techniques around the world.
            </p>
            <p>
                It is part of our social mission to protect all the personal information we handle, and we abide by all laws and regulations concerning the protection of individuals and information.
            </p>
            <ul>
                <li>
                    For the provision of our services, we will collect and use our customers' personal information as required and in an appropriate manner.
                </li>
                <li>
                    To protect the personal information of our customers, we will conduct thorough safety management.
                </li>
                <li>
                    We will respect the privacy rights of our customers. If they ask us for personal information, we will respond promptly as required by law.
                </li>
            </ul>
            <p>
                Our privacy policy describes how and why we handle your personal information when you use any of the services we provide (hereinafter referred to as "the Services").
            </p>
            <section>
                <h4>
                    Acquisition of personal information
                </h4>
                <p>
                    When acquiring personal information (Name, Date of Birth, etc), OPExPARK clearly states the purpose of obtaining the information and the scope of its usage in business activities. With the prior permission of customers, we appropriately and fairly acquire and use personal information within the limitations of the purpose for obtaining the information. We do not share the personal information of our customers with third parties (including third parties outside Japan) unless we have received permission from the customer in advance, or there are special legal or other justifiable reasons for doing so.
                </p>
            </section>
            <section>
                <h4>
                    Purpose of use of personal information
                </h4>
                <p>
                    The Company may use personal information for the following purposes.
                </p>
                <dl>
                    <dt>
                        In this policy, we disclose the purpose of our use of personal information about members of the surgery education website opeXpark, as well as information we acquire on our corporate site, academic societies, exhibitions, and other events.
                    </dt>
                    <dd>
                        <p>
                            Personal information will be used for the following purposes.
                        </p>
                        <ul>
                            <li>
                                Customer identification and authentication
                            </li>
                            <li>
                                To respond to your inquiries and improve our service.
                            </li>
                            <li>
                                System maintenance, improvement, and troubleshooting
                            </li>
                            <li>
                                Preventing unauthorized access, spam, and other forms of abuse
                            </li>
                            <li>
                                Research and study in the medical field
                            </li>
                            <li>
                                Providing and collecting academic and medical information, including surgical information
                            </li>
                            <li>
                                The provision and collection of medical and academic information, including surgical information, for medical professionals and information about daily life, management, etc. for medical professionals.
                            </li>
                            <li>
                                An analysis of customer data regarding the Service
                            </li>
                            <li>
                                Improvements to the Service and the creation of new services based on the analysis of the service's usage by customers
                            </li>
                            <li>
                                Advertisements and information about the Company's products and services, as well as third-party products and services
                            </li>
                            <li>
                                Engage in events and seminars hosted by the company or by a third party, participate in questionnaires surveys, and send direct mail.
                            </li>
                            <li>
                                We provide advertising and other information related to the products and services of the company and third parties. We also provide internal education and marketing activities for the company and pharmaceutical companies, medical device companies, and other third parties.
                            </li>
                        </ul>
                    </dd>
                    <dt>
                        Purpose of use of personal information related to patients
                    </dt>
                    <dd>
                        <p>
                            We will use personal information for the following purposes
                        </p>
                        <ul>
                            <li>
                                To support future medical technology and research, personal information will be compiled into a database.
                            </li>
                            <li>
                                To create educational materials and share the contents with medical institutions and doctors in Japan and overseas who use the electronic materials.
                            </li>
                            <li>
                                Research and study in the medical field
                            </li>
                            <li>
                                Advertising related to the products and services of the Company or third parties
                            </li>
                            <li>
                                These activities contribute to the development and dissemination of medical science and medical technology, as well as internal training and sales for pharmaceutical firms, medical device firms, etc.
                            </li>
                        </ul>
                    </dd>
                    <dt>
                        Purpose of use of personal information of applicants for employment
                    </dt>
                    <dd>
                        <p>
                            We will use personal information for the following purposes
                        </p>
                        <ul>
                            <li>
                                Examination, determination, and communication of approval or rejection
                            </li>
                        </ul>
                        <p>
                            The Company may change the purposes of use of personal information described in section 2 (Purposes of use of personal information) if it reasonably believes that it is pertinent.
                        </p>
                    </dd>
                </dl>
            </section>
            <section>
                <h4>
                    Appropriate acquisition of personal information
                </h4>
                <p>
                    To protect your privacy, the Company will only acquire personal information through lawful means, not through deception.
                </p>
            </section>
            <section>
                <h4>
                    Safe management of personal information
                </h4>
                <p>
                    To maintain the safety of personal information, the Company will conduct the necessary and appropriate supervision of its employees to prevent risks such as loss, destruction, falsification, leaks, etc. In addition, we may entrust all or parts of the handling of personal information to a third party under the purposes of use stipulated in the Personal Information Protection Policy (Privacy Policy) for the maintenance and operation of websites and systems, the processing and analysis of various survey results, etc.<br />
                    However, the account and password acquired when utilizing this service must be managed on the customers' own accord following the terms of service.
                </p>
            </section>
            <section>
                <h4>
                    Provision to third parties
                </h4>
                <p>
                    The Company does not provide personal information of its members to third parties unless the prior consent of its members has been obtained and unless the following cases are specified.
                </p>
                <dl>
                    <dt>
                        Disclosure when permitted by laws and regulations
                    </dt>
                    <dt>
                        When it is necessary for the protection of human life, body, or property, and obtaining the member's consent is difficult
                    </dt>
                    <dt>
                        In cases where disclosure is particularly necessary to improve public health or promote a child's growth, it is difficult to obtain the consent of the member.
                    </dt>
                    <dt>
                        When it is necessary to cooperate with a national agency, local government, or someone entrusted by the national government in executing the law and regulation-based undertakings, obtaining the consent of the member is likely to hinder such endeavors.
                    </dt>
                    <dt>
                        During mergers or other reorganization-related situations, personal information may be provided.
                    </dt>
                    <dt>
                        The provision of personal information to customers (mainly pharmaceutical companies and medical device companies) for the use of that information for business activities such as marketing, research, and development of products, and internal education.
                    </dt>
                    <dt>
                        When it is necessary to achieve the purposes outlined in Section 2 (Use of personal information)
                    </dt>
                </dl>
                <p>
                    In addition, if the individual concerned requests it, the Company would stop sharing personal information about the individual. Please reach out to the inquiry desk described on this page.
                </p>
            </section>
            <section>
                <h4>
                    Disclosure of personal information
                </h4>
                <p>
                    Following the provisions of the Personal Information Protection Act, when a member requests disclosure of personal information, the Company will disclose it to the member without delay after confirming that it is a request from the member himself/ herself. (We will notify you if the information does not exist.) However, the Company cannot disclose the information if it is not obligated to do so under the Personal Information Protection Act or another law or regulation.
                </p>
            </section>
            <section>
                <h4>
                    Suspension of use of personal information
                </h4>
                <p>
                    Members may request that the Company suspend the use of or erase their personal information (hereinafter referred to as a "suspension of use or deletion") following the provisions of the Personal Information Protection Law if they believe that their personal information was handled beyond the stated purposes or obtained by deception or other improper means.
                </p>
                <p>
                    A member's request will be confirmed by the Company if there is a reason for it. As soon as this is confirmed, the company will stop using the member's personal information without delay. However, this does not apply in certain cases where the Company is not legally required to cease using personal information, such as under the Personal Information Protection Law and other laws.
                </p>
            </section>
            <section>
                <h4>
                    Use of Cookies and Other Technologies
                </h4>
                <p>
                    Cookies and other similar technologies may be used in the Service. We use cookies to display websites optimally to improve usability when users browse them and to statistically investigate and analyze site access. You can decline or restrict the receipt of cookies using the associated browser setting. However, some features of the website may not be available in certain cases.
                </p>
            </section>
            <section>
                <h4>
                    Security
                </h4>
                <p>
                    To ensure privacy and security, member information is password-protected. And to protect data transmission, we use industry-standard SSL encryption.
                </p>
            </section>
            <section>
                <h4>
                    Revision of this policy
                </h4>
                <p>
                    The Company will review its personal information handling practices periodically to make continual improvements and may revise this policy in part. Important updates to this policy will be announced on the website.
                </p>
            </section>
            <section>
                <h4>
                    Inquiries about privacy
                </h4>
                <p>
                    If you have any comments or inquiries regarding the privacy policy, please contact us at <a href="mailto:info@opexpark.co.jp">info@opexpark.co.jp</a>.
                </p>
            </section>
            <p>
                Last revised date: Feb. 02, 2022
            </p>
        </StyledPrivacypolicyBody>
    );
};
